__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/81f9a41bad10f7713f1c5ce0b7f04106b5523854/_next/";